'use strict';

const CONTACTS =
  {
    PRIMARY_CONTACT: 'PRIMARY_CONTACT',
    ALTERNATE_CONTACT: 'ALTERNATE_CONTACT',
    PRIMARY_PURCHASER: 'PRIMARY_PURCHASER',
    ALTERNATE_PURCHASER: 'ALTERNATE_PURCHASER',
    PRIMARY_APPROVER: 'PRIMARY_APPROVER',
    ALTERNATE_APPROVER: 'ALTERNATE_APPROVER',
    PRIMARY_SUPERVISOR: 'PRIMARY_SUPERVISOR',
    ALTERNATE_SUPERVISOR: 'ALTERNATE_SUPERVISOR'
  };

module.exports = CONTACTS;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/contact.constant.js
// module id = hIRx
// module chunks = 1